<template>
  <v-container fill-height>
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 md6>
        <v-card>
          <v-toolbar>
            <v-toolbar-title>
              <span>{{ storename }}</span>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert color="error" icon="warning" v-show="showedError">
              ログインに失敗しました
            </v-alert>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="username"
                :rules="emailRules"
                prepend-icon="person"
                name="login"
                label="Login"
                type="text"
                required
              >
              </v-text-field>
              <v-text-field
                v-model="password"
                :rules="passRules"
                prepend-icon="lock"
                name="password"
                label="Password"
                id="password"
                type="password"
                required
              >
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn block @click="clickLogin">Login</v-btn>
          </v-card-actions>
          <v-card-text>
            <p class="text-center" @click="clickPasswordRest">
              パスワードをお忘れの方はこちら
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Firebase from "firebase";

export default {
  data: function() {
    return {
      valid: true,
      showedError: false,
      username: "",
      password: "",
      emailRules: [
        v => !!v || "必須項目です",
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mailを入力して下さい"
      ],
      passRules: [
        v => !!v || "必須項目です",
        v => (v && v.length >= 6) || "6文字以上で入力して下さい"
      ],
      isProcessLogin: false
    };
  },
  beforeCreate: function() {
    this.storename = process.env.VUE_APP_STORE_NAME || "Crossfit Admin Login";
  },
  methods: {
    clickPasswordRest: function() {
      this.$router.push({ path: "/admin/passwordreset" });
    },
    clickLogin: async function() {
      if (!this.$refs.form.validate() || this.isProcessLogin) {
        return;
      }
      this.isProcessLogin = true;
      await Firebase.auth()
        .signInWithEmailAndPassword(this.username, this.password)
        .then(
          user => {
            this.setNextRoot(user.user);
          },
          () => {
            this.showedError = true;
          }
        );
    },
    setNextRoot: async function(user) {
      console.log(user);
      user.getIdTokenResult(true).then(idTokenResult => {
        console.log(idTokenResult);
        if (!idTokenResult.claims.admin) {
          this.showedError = true;
          this.isProcessLogin = false;
          return;
        } else {
          this.$router.push({ path: "/admin/home" });
        }
      });
    }
  }
};
</script>
